import React, { createContext, useContext, useState, useRef } from 'react'

const ResultContext = createContext({})

export const ResultContextProvider = ({ children }) => {
  const [hovered, setHovered] = useState('')
  const timeoutRef = useRef()

  return <ResultContext.Provider value={{ hovered, setHovered, timeoutRef }}>{children}</ResultContext.Provider>
}

const useResultContext = () => {
  return useContext(ResultContext)
}

export default useResultContext
